export default {
    reasonOfReferences: 'دلیل ارجاعات',
    reasonOfReferencesTitle: 'عنوان',
    reasonOfReferencesStatus: 'وضعیت',
    editReasonOfReferences: 'ویرایش دلیل ارجاعات',
    addReasonOfReferences: 'دلیل ارجاعات جدید',
    fileTypeOrUnit: 'نام پرونده یا (آزمایشگاه، رادیولوژی و ...)',


    infertility: 'ناباروری',
    gynecology: 'سلامت',
    obstetric: 'بارداری',
    glands: 'داخلی(غدد) ',
    genetics: 'ژنتیک',
    nourish: 'تغذیه',
    urology: 'اورولوژی',
    legal: 'حقوقی',
    lab: 'آزمایش',







}